/*
 * @Author: YuanYuan
 * @Date: 2024-02-28 11:38:54
 * @LastEditTime: 2024-06-17 11:13:02
 * @description: 证书管理常量定义
 */
import i18n from '@/i18n'

export default [
  {
    name: 'ExpiredOptions',
    value: [
      { label: i18n.t('certificates.upcomingExp'), value: 1 }, // 最近过期
      { label: i18n.t('certificates.latestExp'), value: 0 } // 最远过期
    ]
  },
  {
    name: 'CertStatusOptions',
    value: [
      { label: i18n.t('certificates.acceptSuccess'), value: 'ACCEPT_SUCCESS', colorClazz: 'text-color-orange' }, // 接受申请
      { label: i18n.t('certificates.applying'), value: 'APPLYING', colorClazz: 'text-color-gold' }, // 申请中
      { label: i18n.t('certificates.issueSuccess'), value: 'ISSUE_SUCCESS', colorClazz: 'text-color-success' }, // 签发成功
      { label: i18n.t('certificates.issueFailure'), value: 'ISSUE_FAILURE', colorClazz: 'text-color-error' }, // 签发失败
      { label: i18n.t('certificates.canceledApply'), value: 'CANCELED' }, // 取消申请
      { label: i18n.t('certificates.revoked'), value: 'REVOKED', colorClazz: 'color-red-8' } // 吊销
    ]
  },
  {
    name: 'AutoRenewOptions',
    value: [
      { label: i18n.t('common.yes'), value: 'true', bgClazz: 'bg-color-success', colorClazz: 'text-color-success', tips: i18n.t('certificates.yesAutoRenewTips') }, // 是
      { label: i18n.t('common.no'), value: 'false', bgClazz: 'bg-color-info', colorClazz: 'text-color-info', tips: i18n.t('certificates.noAutoRenewTips') } // 否
    ]
  },
  {
    name: 'DomainVerifyOptions',
    value: [
      { label: i18n.t('certificates.autoFileVerify'), value: 'true', tips: i18n.t('certificates.autoFileVerifyTips') }, // 自动文件验证
      { label: i18n.t('certificates.manualDnsVerify'), value: 'false', tips: i18n.t('certificates.manualDnsVerifyTips') } // 手动DNS验证
    ]
  },
  {
    name: 'UploadMethodOptions',
    value: [
      { label: i18n.t('certificates.importCertFile'), value: 1 }, // 从证书文件导入
      { label: i18n.t('certificates.pasteCertCtn'), value: 2 }, // 粘贴证书内容
      { label: i18n.t('certificates.oneClickCert'), value: 3 } // 一键证书
    ]
  }
]
